import { createApp } from 'vue';
import DocxToPdfAConverter from '@/Components/DocxToPdfAConverter.vue';
import '@styles/app.css';

createApp(DocxToPdfAConverter).mount('#docx-to-pdfa-converter');
